import { render } from "./Measurements.vue?vue&type=template&id=79d0aff4&scoped=true"
import script from "./Measurements.vue?vue&type=script&lang=js"
export * from "./Measurements.vue?vue&type=script&lang=js"

import "./Measurements.vue?vue&type=style&index=0&id=79d0aff4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d0aff4"]])

export default __exports__